import clsx from 'clsx'
import type { StackProps } from '../stack/stack'
import { Stack } from '../stack/stack'

type CardProps = {
  border?: boolean
  raised?: boolean
  radius?: 'none' | 'sm' | 'md' | 'lg'
  className?: string
}

export const Card = ({
  border,
  children,
  raised,
  radius = 'md',
  className,
  ...props
}: CardProps & StackProps) => {
  return (
    <Stack
      {...props}
      className={clsx([
        'card',
        `radius-${radius}`,
        border && 'border',
        raised && 'raised',
        className,
      ])}
    >
      {children}
    </Stack>
  )
}
